import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/finish_shadow_bg.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 100%;
	height: 100%;
	transform: translate(-50%, -50%);
	z-index: 10;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.finish-enter {
		opacity: 0;
	}

	&.finish-enter-active,
	&.finish-enter-done,
	&.finish-exit {
		opacity: 1;
	}

	&.finish-exit-active {
		opacity: 0;
	}
`;

const StyledBg = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 4;
	background-color: #111314;
	opacity: 0.9;
`;

const StyledBgCircle = styled.div`
	position: absolute;
	width: 2000px;
	height: 2000px;
	left: 50%;
	top: 50%;
	z-index: 5;
	transform: translate(-50%, -50%);
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledResultContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 6;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledItemsContainer = styled.div`
	display: flex;
	gap: 20px;
	flex-wrap: wrap;
	justify-content: center;
	width: 680px;
`;

const StyledContinueButton = styled.button`
	margin-top: 20px;
	padding: 0 20px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	border: none;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	align-items: center;
	justify-content: center;
	width: 120px;
	min-width: 120px;
	height: 120px;
	padding-top: 2px;
	background: linear-gradient(
		360deg,
		rgba(255, 255, 255, 0.05) 0%,
		rgba(255, 255, 255, 0) 100%
	);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}
`;

export {
	StyledBg,
	StyledBgCircle,
	StyledContainer,
	StyledContinueButton,
	StyledItem,
	StyledItemsContainer,
	StyledResultContainer,
};
